import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconTooltipButton from '../button/IconTooltipButton'

const SectionCollapse = ({ title, classNameBody = '', children, actions, color = 'primary', styleTitle = {}, expandDefault = true }) => {
  const [open, setOpen] = useState(expandDefault)
  return (
    <>
      <Box 
        className={
          [
            color === 'primary' ? 'bg-primary text-primary-foreground' : 'bg-white text-primary',
            'px-4 py-1 flex justify-between items-center gap-1 h-8'
          ].join(' ')
        }
        style={styleTitle}
      >
        <Typography variant='subtitle1' className='uppercase'>{title}</Typography>
        <div className='flex justify-end gap-1 items-center'>
          {actions}
          <IconTooltipButton
            title={open ? 'Hide' : 'Show'}
            icon={open ? 'chevron-up' : 'chevron-down'}
            onClick={() => setOpen(!open)}
            className='text-primary-foreground'
            color={color === 'primary' ? "secondary" : "primary"}
          />
        </div>
      </Box>
      <Box className={['px-2 py-2', classNameBody].join(' ')}>
        {open && children}
      </Box>
    </>
  )
}

export default SectionCollapse